export default function isValidAddress(address) {
  return /[0-9]/.test(address);
}
